import script from "./UserInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserInfo.vue?vue&type=script&lang=ts&setup=true"

import "./UserInfo.vue?vue&type=style&index=0&id=69267ae7&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69267ae7"]])

export default __exports__